<div class="overview-main" id="overview">
  <div class="overview-nav">
    <div class="overview-close" (click)="close(true)">
      <img src="assets/general/cross-blue.svg" />
    </div>
    <div class="overview-title">جزئیات برنامه غذایی</div>
  </div>
  <div class="overview-table">
    <div
      *ngFor="let id of componentIds; let i = index"
      class="overview-cell"
      (click)="openOverviewDetail(id)"
    >
      <div class="overview-cell-title">{{ titles[id] }}</div>
      <div
        [ngClass]="
          values[id] === 'مشخص کنید'
            ? 'overview-cell-set-value'
            : 'overview-cell-value'
        "
      >
        {{ values[id] }}
      </div>
      <img class="overview-cell-edit" src="assets/general/left-gray.svg" />
    </div>
  </div>
</div>
<div class="overview-detail" *ngIf="showDetail" id="overview-detail">
  <div class="overview-nav">
    <div class="overview-detail-close" (click)="closeOverviewDetail()">
      <img src="assets/general/back-blue.svg" />
    </div>
    <div class="overview-title">تغییرات</div>
  </div>
  <app-diet-type
    *ngIf="selectedDetail === 0"
    class="overview-detail-main"
    [isDetail]="true"
  ></app-diet-type>
  <app-diet-personal-type
    *ngIf="selectedDetail === 1"
    class="overview-detail-main"
    [isDetail]="true"
  ></app-diet-personal-type>
  <app-weight
    *ngIf="selectedDetail === 2"
    [currentPageNumber]="selectedDetail"
    [pageNumber]="2"
    [type]="'start'"
    [isDetail]="true"
  ></app-weight>
  <app-activity-level
    *ngIf="selectedDetail === 3"
    [currentPageNumber]="selectedDetail"
    [pageNumber]="3"
    [isDetail]="true"
  ></app-activity-level>
  <app-vegetarian
    *ngIf="selectedDetail === 4"
    [currentPageNumber]="selectedDetail"
    [pageNumber]="4"
    [isDetail]="true"
  ></app-vegetarian>
  <app-disease
    *ngIf="selectedDetail === 5"
    [currentPageNumber]="selectedDetail"
    [pageNumber]="5"
    [isDetail]="true"
  ></app-disease>
  <app-hated-foods
    *ngIf="selectedDetail === 6"
    [currentPageNumber]="selectedDetail"
    [pageNumber]="6"
    [isDetail]="true"
  ></app-hated-foods>
  <app-difficulty
    *ngIf="selectedDetail === 7"
    [currentPageNumber]="selectedDetail"
    [pageNumber]="7"
    [isDetail]="true"
  ></app-difficulty>
  <app-start-date
    *ngIf="selectedDetail === 8"
    [currentPageNumber]="selectedDetail"
    [pageNumber]="8"
    [isDetail]="true"
  ></app-start-date>
  <app-date
    *ngIf="selectedDetail === 9"
    [currentPageNumber]="selectedDetail"
    [pageNumber]="9"
    [type]="'pregnancy'"
    [isDetail]="true"
  ></app-date>
  <app-date
    *ngIf="selectedDetail === 10"
    [currentPageNumber]="selectedDetail"
    [pageNumber]="10"
    [type]="'breastfeeding'"
    [isDetail]="true"
  ></app-date>
  <app-fasting-days
    *ngIf="selectedDetail === 11"
    [currentPageNumber]="selectedDetail"
    [pageNumber]="11"
    [isDetail]="true"
  ></app-fasting-days>
</div>
<app-loading *ngIf="showLoading"></app-loading>
<app-submit-button [title]="buttonTitle"></app-submit-button>
<app-popup *ngIf="showPopup" [input]="popupInputModel"></app-popup>
